import { db } from './firebase';
import { collection, addDoc, getDocs, query, where, Timestamp } from 'firebase/firestore';

interface InstallationData {
  domain: string;
  installedAt: Date;
  lastPing: Date;
  active: boolean;
}

export const trackInstallation = async () => {
  try {
    const domain = window.location.hostname;
    const installationsRef = collection(db, 'installations');
    
    // Check if already installed on this domain
    const q = query(installationsRef, where('domain', '==', domain));
    const existing = await getDocs(q);
    
    if (existing.empty) {
      // New installation
      await addDoc(installationsRef, {
        domain,
        installedAt: new Date(),
        lastPing: new Date(),
        active: true
      });
    } else {
      // Update last ping
      const doc = existing.docs[0];
      await doc.ref.update({
        lastPing: new Date(),
        active: true
      });
    }
  } catch (error) {
    console.error('Error tracking installation:', error);
  }
};

export const getInstallationStats = async () => {
  try {
    const installationsRef = collection(db, 'installations');
    const snapshot = await getDocs(installationsRef);
    
    return {
      total: snapshot.size,
      active: snapshot.docs.filter(doc => doc.data().active).length,
      installations: snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as InstallationData[]
    };
  } catch (error) {
    console.error('Error getting installation stats:', error);
    throw error;
  }
};